module.exports = __webpack_public_path__ + "static/logo-cf26f88bad23392a8fa88a0250f82025.svg";